var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.IModal,{class:_vm.$style.modal,attrs:{"id":"cart-modal","text-cancel":"買い物を続ける","text-ok":"カートに進む","with-action-button":true},on:{"cancel":_setup.modalClose,"ok":_setup.goToCart,"close":_setup.modalClose}},[_c('p',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }